// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { DateTime } from 'luxon';

/**
 * Formats a 3PL sync timestamp as "Jun 5, 2026 @ 1:47pm PDT" for the sync-status
 * tooltip. The meridiem is lowercased to match the agreed display style.
 */
export function format3plSyncTimestamp(value: DateTime): string {
  const datePart = value.toFormat("LLL d, yyyy '@' h:mm");
  const meridiem = value.toFormat('a').toLowerCase();
  const zone = value.toFormat('ZZZZ');
  return `${datePart}${meridiem} ${zone}`;
}
